import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NoteOption } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';

/**
 * API client for the persisted note-options catalog.
 * Mirrors the backend NoteOptionsService extracted from InspectionService;
 * keeping the frontend service split 1-1 with the backend service split makes
 * future role-filtered or write-side endpoints additive instead of forcing
 * further surgery on InspectionApiService.
 */
@Injectable({
    providedIn: 'root',
})
export class NoteOptionsApiService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);

    /**
     * Retrieves the role-filtered note-options catalog for every item in an inspection,
     * keyed by inspection item id. One HTTP request per inspection open. Items with no
     * catalog rows appear in the map with an empty array so callers can rely on a
     * complete keyset. Techs receive Approved entries; tenant admins receive Approved
     * and PendingReview.
     */
    getNoteOptionsForInspection(tenantId: string, branchId: string, inspectionId: string): Observable<Record<string, NoteOption[]>> {
        return this.http.get<Record<string, NoteOption[]>>(
            this.serviceUtils.getBaseUrl('inspection', tenantId, branchId) + `/${inspectionId}/item-note-options`,
        );
    }
}
